export default "__VITE_ASSET__Bcf20YGc__"